module.exports = __webpack_public_path__ + "img/Taiwan-5-hover.98d85d63.jpg";